import { useMemo } from "react";
import { isFeatureAvailable, Feature } from "@functions/featureAvailability";
import { useCurrentWorkspace } from "@rapid/hooks/useCurrentWorkspace";

export const useVisibilityThroughWorkspace = () => {
    const { currentWorkspaceUsage } = useCurrentWorkspace();

    const visibilityThroughWorkspace = useMemo(() => {
        const privateDataThroughWorkspace =
            currentWorkspaceUsage &&
            isFeatureAvailable(Feature.PrivateProjects, currentWorkspaceUsage);
        return privateDataThroughWorkspace ? "private" : "public";
    }, [currentWorkspaceUsage]);

    return visibilityThroughWorkspace;
};
